import React from 'react'

import {
  StyleSheet,
  View,
} from 'react-native';
import PromoCodeEditor from '../components/payments/PromoCodeEditor';

interface Props {
}

const PromoCodeEditorScreen: React.FC<Props> = ({ 
}) => {   
  return ( 
    <View style={styles.container}>
      <PromoCodeEditor />
    </View>
  )
};

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    flex: 1,
    width: "100%"
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 20
  }
});

export default PromoCodeEditorScreen